/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, Col, Row, Button } from "reactstrap";
// axios
import axios from "axios";
// alerta
import { useFormValidation } from "./hooks/useFormValidation";

import SweetAlert from "react-bootstrap-sweetalert";
//service
import { editEvent } from "../../utils/services/events";
import { getEventType } from "../../utils/services/eventType";
//redux
import { connect } from "react-redux";
import ButtonSpinner from "../../components/Buttons/ButtonSpinner";

function EditEvent(props) {
  const { isOpen, toggle, currentEventSelected } = props;
  const [modalBackdrop, setModalBackdrop] = useState(false);
  const [isLoading, setIsloading] = useState(false);

  //campos do form
  const [title, setTitle] = useState(currentEventSelected.title);
  const [description, setDescription] = useState(
    currentEventSelected.description,
  );
  const [optionLocalization, setOptionLocalization] = useState(
    currentEventSelected.eventFormat === "digital"
      ? ""
      : currentEventSelected.localizations[0].description,
  );
  const [latitude, setLatitude] = useState(
    currentEventSelected.eventFormat === "digital"
      ? ""
      : currentEventSelected.localizations[0].latitude,
  );
  const [longitude, setLongitude] = useState(
    currentEventSelected.eventFormat === "digital"
      ? ""
      : currentEventSelected.localizations[0].longitude,
  );
  const [editLatLon, setEditLatLon] = useState(false);

  const [selectedGroup, setselectedGroup] = useState(
    currentEventSelected.eventFormat,
  );
  // tipos de eventos
  const [eventTypes, setEventTypes] = useState([]);
  const [eventTypesSelected, setEventTypesSelected] = useState(
    currentEventSelected.category,
  );

  const [startDate, setStartDate] = useState(currentEventSelected.startDate);
  const [endDate, setEndtDate] = useState(currentEventSelected.endDate);
  const [startHour, setStartHour] = useState(currentEventSelected.startHour);
  const [endHour, setEndHour] = useState(currentEventSelected.endHour);
  const [productsSelected, setProductsSelected] = useState([]);
  //produtos
  const [productsList, setProductsList] = useState([]);
  // localização
  const [localizationSelected, setLocalizationSelected] =
    useState(optionLocalization);
  //erro dos campos obrigatórios
  // const [titleError, setTitleError] = useState("");
  // const [dateStartError, setDateStartError] = useState("");
  // const [productsError, setProductsError] = useState("");
  // const [eventFormatError, setEventFormatError] = useState("");
  // const [menuLogoError, setMenuLogoError] = useState("");
  // const [localizationError, setLocalizationError] = useState("");
  //confirmação
  const [success_dlg, setsuccess_dlg] = useState(false);
  // dados da requisição
  const token = props.state.global_user_data.data.token;

  const {
    titleError,
    eventFormatError,
    localizationError,
    dateStartError,
    dateEndError,
    hourStartError,
    hourEndError,
    productsError,
    validate,
  } = useFormValidation("edit");

  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }

  function handleSelectGroup(e) {
    setselectedGroup(e);
  }

  function setProductCheck(item, check) {
    if (check) {
      setProductsSelected((prev) => [...prev, item.idmainproduct]);
    } else {
      setProductsSelected((prev) =>
        prev.filter((e) => e !== item.idmainproduct),
      );
    }
  }

  function getProductChecked(item) {
    var product = currentEventSelected.product.filter(
      (e) => e.id === item.idmainproduct,
    );

    if (product.length > 0) {
      return true;
    } else return false;
  }

  const submitEdit = async (e) => {
    e.preventDefault();

    const isValid = validate({
      title,
      selectedGroup,
      localizationSelected,
      startDate,
      endDate,
      startHour,
      endHour,
      productsSelected,
    });

    const descriptionLocalization =
      selectedGroup?.value !== "digital" ? optionLocalization : "";

    setIsloading(true);
    if (!isValid) {
      setIsloading(false);
      return;
    }
    const objEvento = {
      codEvent: "",
      description: description,
      title: title,
      category: eventTypesSelected === "Selecione" ? "" : eventTypesSelected,
      eventFormat: selectedGroup,
      startDate: new Date(`${startDate}T00:01`).toISOString(),
      endDate: new Date(
        `${endDate === "" ? startDate : endDate}T00:01`,
      ).toISOString(),
      startHour: startHour !== "" ? startHour : "00:00",
      endHour: endHour !== "" ? endHour : "00:00",
      enabled: true,
      localizations: [{ description: descriptionLocalization }],
      products: productsSelected,
      latitude: latitude,
      longitude: longitude,
      showCompany: currentEventSelected.showCompany,
      showJobPosition: currentEventSelected.showJobPosition,
    };

    await editEvent(objEvento, token, currentEventSelected.id)
      .then((res) => {
        // console.log("ok", res);
        setIsloading(false);
        if (res.message === "updated") {
          setsuccess_dlg(true);
        }
      })
      .catch((error) => {
        setIsloading(false);
        console.log("erro", error);
      });
  };

  function selectedLocale(l) {
    setLocalizationSelected(l);
    document.getElementById("localInput").value = l.description;
    setOptionLocalization(l.description);
  }

  function localization(e) {
    setLocalizationSelected("");
    axios
      .get(
        `https://us-central1-inteegra-ping.cloudfunctions.net/GoogleAutoComplete?search=${e}&language=pt`,
      )
      .then((localizations) => {
        if (localizations.data.success.status === "OK") {
          setOptionLocalization(localizations);
        }
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  function getProductsSelected() {
    setProductsSelected(currentEventSelected.product.map((e) => e.id));
  }

  function getProducts() {
    var listProducts = [];
    props.state.global_user_data.data.foundProducts.forEach((product) => {
      const alreadyAdded = listProducts.some(
        (e) => e.namemainproduct === product.namemainproduct,
      );

      if (!alreadyAdded) {
        listProducts.push({
          namemainproduct: product.namemainproduct,
          idmainproduct: product.idmainproduct,
        });
      }
    });

    setProductsList(
      listProducts.filter((f) => f.namemainproduct !== "Telas de Configuração"),
    );
  }

  async function getListEventType() {
    const res = await getEventType({
      jwt: token,
      offset: 1,
      limit: 1000,
      search: "",
      active: "",
    });

    if (res.message === "findEventTypes") {
      const searchTypes = res.findEventTypesData.data.filter(
        (e) => e.id === currentEventSelected.category,
      );
      const activeTypes = res.findEventTypesData.data.filter((e) => e.active);

      const listTypes =
        searchTypes[0] && !searchTypes[0].active
          ? [...activeTypes, searchTypes[0]]
          : activeTypes;

      setEventTypes(listTypes);
    }
  }

  function formatDateToInput(isoDate) {
    const d = new Date(isoDate);
    const dia = String(d.getDate()).padStart(2, "0");
    const mes = String(d.getMonth() + 1).padStart(2, "0");
    return `${d.getFullYear()}-${mes}-${dia}`;
  }

  function getDateFunc() {
    if (startDate) setStartDate(formatDateToInput(startDate));
    if (endDate) setEndtDate(formatDateToInput(endDate));
  }

  useEffect(() => {
    getProducts();
    getProductsSelected();
    getDateFunc();
    getListEventType();
  }, [currentEventSelected]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggleBackdrop();
      }}
      autoFocus={true}
      centered={true}
    >
      {success_dlg ? (
        <SweetAlert
          success
          title={"Editado"}
          onConfirm={() => {
            props.getAllEvents();
            setsuccess_dlg(false);
            toggle();
          }}
        >
          {"Evento editado com sucesso!"}
        </SweetAlert>
      ) : null}
      <ModalHeader toggle={toggle}>Editar Evento</ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            <div>
              <label className="form-label"> ID do Evento</label>
              <input
                className="form-control"
                type="text"
                value={currentEventSelected.id}
                disabled
              />
            </div>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={6}>
            <div>
              <label className="form-label"> Nome do Evento*</label>
              <input
                className="form-control"
                type="text"
                defaultValue={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              <p style={{ color: "red" }}>{titleError}</p>
            </div>
          </Col>
          <Col lg={6}>
            <div>
              <label className="form-label">Tipo de evento</label>
              <select
                className="form-control"
                value={eventTypesSelected}
                onChange={(e) => {
                  setEventTypesSelected(e.target.value);
                }}
              >
                <option value={"Selecione"}>Selecione</option>
                {eventTypes.length > 0 &&
                  eventTypes.map((e, i) => (
                    <option key={i} value={e.id}>
                      {e.type}
                    </option>
                  ))}
              </select>
            </div>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={12}>
            <div>
              <label className="form-label">Descrição</label>
              <textarea
                className="form-control"
                type="text"
                defaultValue={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={12}>
            <div>
              <label className="form-label">Formato do Evento*</label>
              <select
                className="form-control"
                value={selectedGroup}
                onChange={(e) => {
                  handleSelectGroup(e.target.value);
                  setEditLatLon(false);
                }}
              >
                <option value="presencial">Presencial</option>
                <option value="digital">Digital</option>
                <option value="hibrido">Híbrido</option>
              </select>
              <p style={{ color: "red" }}>{eventFormatError}</p>
            </div>
          </Col>
        </Row>

        {selectedGroup !== "digital" && (
          <>
            <Row style={{ marginTop: 10 }}>
              <Col lg={12}>
                <div>
                  <label className="form-label">Localização*</label>
                  <input
                    className="form-control"
                    type="text"
                    id="localInput"
                    defaultValue={optionLocalization}
                    onChange={(e) => {
                      localization(e.target.value);
                      setLatitude("");
                      setLongitude("");
                    }}
                  />
                  <p style={{ color: "red" }}>{localizationError}</p>
                </div>
                {optionLocalization.data && optionLocalization.data.success ? (
                  <ul className="localization">
                    {optionLocalization.data.success.predictions.map((l) => {
                      return (
                        <li
                          key={l.description}
                          className="localizationLi"
                          onClick={() => selectedLocale(l)}
                        >
                          {l.description}
                        </li>
                      );
                    })}
                  </ul>
                ) : null}
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <div
                  className="form-check form-switch"
                  style={{
                    borderTop: "1px solid #dbdbdb",
                    borderBottom: "1px solid #dbdbdb",
                    marginTop: 5,
                    marginBottom: 5,
                    paddingTop: 5,
                    paddingBottom: 5,
                  }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id={`checkLatLon`}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setEditLatLon(true);
                      } else setEditLatLon(false);
                    }}
                  />
                  <label className="form-check-label" htmlFor={`checkLatLon`}>
                    Editar Latitude/Longitude
                  </label>
                </div>
              </Col>
            </Row>

            {editLatLon && (
              <Row style={{ marginTop: 2 }}>
                <Col lg={6}>
                  <div>
                    <label className="form-label">Latitude</label>
                    <input
                      value={latitude}
                      className="form-control"
                      type="text"
                      onChange={(e) => setLatitude(e.target.value)}
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div>
                    <div>
                      <label className="form-label">Longitude</label>
                      <input
                        value={longitude}
                        className="form-control"
                        type="text"
                        onChange={(e) => setLongitude(e.target.value)}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            )}
          </>
        )}

        <Row style={{ marginTop: 10 }}>
          <Col lg={6}>
            <div>
              <label className="form-label">Data Inicio*</label>
              <input
                className="form-control"
                type="date"
                value={startDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                }}
              />
              <p style={{ color: "red" }}>{dateStartError}</p>
            </div>
          </Col>
          <Col lg={6}>
            <div>
              <label className="form-label">Data Fim</label>
              <input
                className="form-control"
                type="date"
                value={endDate}
                onChange={(e) => setEndtDate(e.target.value)}
                min={startDate || ""}
              />
              <p style={{ color: "red" }}>{dateEndError}</p>
            </div>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={6}>
            <div>
              <label className="form-label">Hora Inicio</label>
              <input
                className="form-control"
                type="time"
                defaultValue={startHour}
                onChange={(e) => setStartHour(e.target.value)}
              />
              <p style={{ color: "red" }}>{hourStartError}</p>
            </div>
          </Col>
          <Col lg={6}>
            <div>
              <label className="form-label">Hora Fim</label>
              <input
                className="form-control"
                type="time"
                defaultValue={endHour}
                onChange={(e) => setEndHour(e.target.value)}
              />
              <p style={{ color: "red" }}>{hourEndError}</p>
            </div>
          </Col>
        </Row>

        <Row style={{ marginTop: 18 }}>
          <p style={{ marginBottom: 14, fontWeight: "bold" }}>
            Selecione o(s) produto(s) do evento:*
          </p>
        </Row>

        {productsList &&
          productsList
            .sort((a, b) => a.namemainproduct.localeCompare(b.namemainproduct))
            .map((item, i) => (
              <Row key={i}>
                <Col md={12}>
                  <div className="form-check form-switch">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={item.idmainproduct}
                      defaultChecked={getProductChecked(item)}
                      onChange={(e) => {
                        setProductCheck(item, e.target.checked);
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={item.idmainproduct}
                    >
                      {item.namemainproduct}
                    </label>
                  </div>
                </Col>
              </Row>
            ))}

        {productsError && (
          <Row>
            <Col>
              <p style={{ color: "red" }}>{productsError}</p>
            </Col>
          </Row>
        )}

        <Row
          style={{
            width: "100%",
            margin: "auto",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            color="success"
            className="btn btn-danger waves-effect waves-light"
            style={{ width: 80 }}
            onClick={() => toggle()}
          >
            Fechar
          </Button>

          <ButtonSpinner
            isLoading={isLoading}
            title={"Salvar"}
            onClick={submitEdit}
            action="U"
            marginLeft={10}
          />
        </Row>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(EditEvent);
